import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 36, className, amount = 0.2 }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: reduce ? 0 : y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px", amount }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0, as = "h2", once = true }) {
  const reduce = useReducedMotion();
  const Tag = as;
  return (
    <Tag className={className}>
      <motion.span
        className="block"
        initial="hidden"
        whileInView="visible"
        viewport={{ once, margin: "-8% 0px" }}
        variants={{
          hidden: {},
          visible: { transition: { staggerChildren: 0.13, delayChildren: delay } },
        }}
      >
        {lines.map((line, i) => (
          <span key={i} className="hero-mask-line">
            <motion.span
              className={`block will-change-transform ${lineClassName}`}
              variants={{
                hidden: { y: reduce ? "0%" : "115%" },
                visible: { y: "0%", transition: { duration: 1.05, ease: EASE } },
              }}
            >
              {line}
            </motion.span>
          </span>
        ))}
      </motion.span>
    </Tag>
  );
}

export function Eyebrow({ children, tone = "saffron", center = false }) {
  const color = tone === "ivory" ? "text-ivory/70" : "text-saffron";
  const rule = tone === "ivory" ? "bg-ivory/40" : "bg-saffron/70";
  return (
    <p
      className={`flex items-center gap-4 text-[11px] font-medium uppercase tracking-[0.32em] ${color} ${
        center ? "justify-center" : ""
      }`}
    >
      <span className={`h-px w-10 ${rule}`} aria-hidden="true" />
      {children}
      {center && <span className={`h-px w-10 ${rule}`} aria-hidden="true" />}
    </p>
  );
}

// Serif section heading in the reference style: plain words in `ink`/`ivory`,
// italic accent words in `leaf` (on cream) or `saffron` (on dark).
export function SectionTitle({ before, accent, after = "", dark = false, center = false, className = "" }) {
  return (
    <h2
      className={`font-serif font-light leading-[1.08] text-[clamp(2.1rem,4.4vw,3.9rem)] ${
        dark ? "text-ivory" : "text-ink"
      } ${center ? "text-center" : ""} ${className}`}
    >
      {before} <em className={dark ? "text-saffron" : "text-leaf"}>{accent}</em>
      {after && ` ${after}`}
    </h2>
  );
}
